import { updateInfo } from "../info";
import { SettingContainer } from "./SettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { InputContainer } from "./InputContainer";
import { TextInput } from "./TextInput";
import { Button } from "./Button";

export function BroadcastInfoSettings(props) {
  function onEpisodeSave(e, value, setDisabled) {
    updateInfo(`/broadcast/${props.broadcast.id}/episode`, { value }, "에피소드", () => {
      props.onSave();
      setDisabled(true);
    });
  }

  function onUnhide(e) {
    updateInfo(`/broadcast/${props.broadcast.id}/hide`, false, "방송 숨김", props.onSave);
  }

  return (<>
    <SettingTitle text="방송 정보"/>

    <SettingContainer>
      <SettingText text="에피소드"/>
      <InputContainer>
        <TextInput id="episode" defaultValue={ props.broadcast.episode } onClick={ onEpisodeSave }/>
      </InputContainer>
    </SettingContainer>

    <SettingContainer>
      <InputContainer>
        { props.broadcast.deleted && <Button text="숨김 해제하기" onClick={ onUnhide }/> }
      </InputContainer>
    </SettingContainer>
  </>);
}
